module.exports = __webpack_public_path__ + "img/user_icon.375c36d4.png";